import locationApi from '~/locationApi';
import { LocationPickerResponse } from '~/screens/MyAgency/components/SearchLocation';

export type UseGetLocationSuggestionsProps = {
  onError?: (error: Error) => void;
};

export function useGetLocationSuggestions({
  onError,
}: UseGetLocationSuggestionsProps = {}) {
  const getSuggestions = (
    query: string,
  ): Promise<LocationPickerResponse> | null => {
    if (!query.trim()) return null;
    return locationApi
      .get(`/locations/suggest?q=${query}`)
      .then((response) => response.data)
      .catch(onError);
  };

  return {
    getSuggestions,
  };
}
